import { render, staticRenderFns } from "./WorkPlaceAddress.vue?vue&type=template&id=0a2caccc&scoped=true&"
import script from "./WorkPlaceAddress.vue?vue&type=script&lang=js&"
export * from "./WorkPlaceAddress.vue?vue&type=script&lang=js&"
import style0 from "./WorkPlaceAddress.vue?vue&type=style&index=0&id=0a2caccc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2caccc",
  null
  
)

export default component.exports